// extracted by mini-css-extract-plugin
module.exports = {"radioBlock":"styles_radioBlock__u1PJZ","checkboxBlock":"styles_checkboxBlock__VDw2P","mainTable":"styles_mainTable__2fsPK","detailsBlock":"styles_detailsBlock__1z55J"};